// Servicio para detectar ubicación del usuario por IP

export const getCountryFromIP = async () => {
  try {
    // Usar ipapi.co que es gratuito y no requiere API key
    const response = await fetch('https://ipapi.co/json/');
    
    if (!response.ok) {
      throw new Error('Error al obtener ubicación');
    }
    
    const data = await response.json();
    
    return {
      country: data.country_name || 'Desconocido',
      countryCode: data.country_code || '',
      city: data.city || '',
      region: data.region || '',
      timezone: data.timezone || '',
    };
  } catch (error) {
    console.error('Error detecting country:', error);
    // Fallback: intentar con otro servicio
    try {
      const response = await fetch('https://api.country.is/');
      const data = await response.json();
      return {
        country: data.country || 'Desconocido',
        countryCode: data.country || '',
        city: '',
        region: '',
        timezone: '',
      };
    } catch (fallbackError) {
      console.error('Error with fallback service:', fallbackError);
      return {
        country: 'Desconocido',
        countryCode: '',
        city: '',
        region: '',
        timezone: '',
      };
    }
  }
};

// Lista de países comunes en español para el selector
export const COUNTRIES = [
  { code: 'AR', name: 'Argentina' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BR', name: 'Brasil' },
  { code: 'CL', name: 'Chile' },
  { code: 'CO', name: 'Colombia' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'CU', name: 'Cuba' },
  { code: 'DO', name: 'República Dominicana' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'ES', name: 'España' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'HN', name: 'Honduras' },
  { code: 'MX', name: 'México' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'PA', name: 'Panamá' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Perú' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'US', name: 'Estados Unidos' },
  { code: 'CA', name: 'Canadá' },
  { code: 'FR', name: 'Francia' },
  { code: 'DE', name: 'Alemania' },
  { code: 'IT', name: 'Italia' },
  { code: 'PT', name: 'Portugal' },
  { code: 'UK', name: 'Reino Unido' },
  { code: 'OTHER', name: 'Otro' },
];
